import React from 'react'
import { HorizontalLoader } from '../../../../../Components'
import useCurrentAdmin from '../../../../../Hooks/Queries/AdminManagement/useCurrentAdmin'

interface AdminAccessGuardProps {
  children: React.ReactNode
  requireSuperAdmin?: boolean
}

// Route guard for the admin-management screens
const AdminAccessGuard: React.FC<AdminAccessGuardProps> = ({
  children,
  requireSuperAdmin = false,
}) => {
  const { isLoading, isError, error, isSuperAdmin, admin } = useCurrentAdmin()

  if (isLoading) {
    return (
      <div className='container mt-5'>
        <HorizontalLoader />
      </div>
    )
  }

  if (isError || !admin) {
    return (
      <div className='container mt-5'>
        <div className='alert alert-danger'>
          Could not verify your admin permissions
          {(error as Error)?.message ? `: ${(error as Error).message}` : '.'}
        </div>
      </div>
    )
  }

  if (requireSuperAdmin && !isSuperAdmin) {
    return (
      <div className='container mt-5'>
        <div className='alert alert-warning'>
          This screen is restricted to super administrators.
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default AdminAccessGuard
